export const toBrl = (value) => {
  return `R$ ${toMoney(value)}`
}

export const toMoney = (value) => {
  return parseFloat(value).toFixed(2).replace('.', ',')
}
